import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SUBSCRIPTION_STATUS } from 'src/app/models/card';
import { UserDataService } from 'src/app/shared/providers/user-data.service';
import { CardsService } from 'src/app/shared/providers/cards.service';

@Component({
  selector: 'app-join-membership-screen',
  templateUrl: './join-membership-screen.component.html',
  styleUrls: ['./join-membership-screen.component.scss']
})
export class JoinMembershipScreenComponent implements OnInit, OnDestroy {
  @Input() isMobile: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() activatedAfterStripeRedirect: boolean = false;
  @Input() mainBtnTitle: string = 'Join';

  @Output() mainBtnClicked = new EventEmitter<void>();
  @Output() backClicked = new EventEmitter<void>();
  @Output() freeTrialClicked = new EventEmitter<void>();

  SUBSCRIPTION_STATUS = SUBSCRIPTION_STATUS;
  appActivationSubscription: Subscription;

  constructor(
    public userDataService: UserDataService,
    public cardService: CardsService
  ) {}

  ngOnInit(): void {
    // This thing is done, when user hits 'back' btn in browser and previous disabled state will be exist forever;
    // So we cancel it on 'appActivation' hook, but not cancel if we wait for confirmation after payment
    this.appActivationSubscription = this.cardService.onApplicationActivationSubject.subscribe(() => {
      if (this.activatedAfterStripeRedirect) return;
      else {
        this.isDisabled = false;
      }
    });
  }

  onMainBtnClick(event: Event): void {
    event.stopPropagation();
    this.mainBtnClicked.emit();
  }

  onBackClick(): void {
    this.backClicked.emit();
  }

  onFreeTrialClick(): void {
    this.freeTrialClicked.emit();
  }

  ngOnDestroy(): void {
    if (this.appActivationSubscription) {
      this.appActivationSubscription.unsubscribe();
    }
  }
}
